import type { Deity } from './types'

export const DEITIES: Deity[] = [
  {
    id: 'vinayagar',
    nameTa: 'விநாயகர்',
    nameEn: 'Vinayagar',
    descriptionTa: 'விக்கினங்களை நீக்கும் முதல் வணக்கத் தெய்வம். பாடல்கள், மந்திரங்கள் மற்றும் ஸ்துதிகள்.',
  },
  {
    id: 'murugan',
    nameTa: 'முருகன்',
    nameEn: 'Murugan',
    descriptionTa: 'தமிழ்க் கடவுள் முருகனின் ஸ்துதிகள், காவடிப் பாடல்கள் மற்றும் அனுபூதி.',
  },
  {
    id: 'shiva',
    nameTa: 'சிவன்',
    nameEn: 'Shiva',
    descriptionTa: 'லிங்காஷ்டகம், பிரதோஷம் மற்றும் சிவபக்திப் பாடல்கள்.',
  },
  {
    id: 'amman',
    nameTa: 'அம்மன்',
    nameEn: 'Amman',
    descriptionTa: 'தேவி ஸ்துதிகள், ஐகிரி நந்தினி, பொற்றித் தொகுப்புகள்.',
  },
  {
    id: 'lakshmi',
    nameTa: 'லக்ஷ்மி',
    nameEn: 'Lakshmi',
    descriptionTa: 'செவ்வாய் / வெள்ளி வழிபாடு மற்றும் மகாலக்ஷ்மி பக்திப் பாடல்கள்.',
  },
  {
    id: 'vishnu',
    nameTa: 'விஷ்ணு & கிருஷ்ணன்',
    nameEn: 'Vishnu & Krishna',
    descriptionTa: 'பாகவத பக்தி, கிருஷ்ண ஜெயந்தி மற்றும் விஷ்ணு ஸ்துதிகள்.',
  },
  {
    id: 'hanuman',
    nameTa: 'அனுமன்',
    nameEn: 'Hanuman',
    descriptionTa: 'தைரியமும் பக்தியும் தரும் அனுமன் ஸ்துதிகள்.',
  },
  {
    id: 'ayyappan',
    nameTa: 'ஐயப்பன்',
    nameEn: 'Ayyappan',
    descriptionTa: 'சபரிமலை காலம் மற்றும் ஐயப்பன் பக்திப் பாடல்கள்.',
  },
  {
    id: 'other',
    nameTa: 'பிற தெய்வங்கள்',
    nameEn: 'Other Deities',
    descriptionTa: 'மற்ற ஆன்மீகப் பாடல்கள் மற்றும் ஸ்துதிகள்.',
  },
]
